"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var LanguageDirection;

(function (LanguageDirection) {
  LanguageDirection[LanguageDirection["Rtl"] = 0] = "Rtl";
  LanguageDirection[LanguageDirection["Ltr"] = 1] = "Ltr";
})(LanguageDirection = exports.LanguageDirection || (exports.LanguageDirection = {}));

var currencyCode_1 = require("./currencyCode");

exports.CurrencyCode = currencyCode_1.CurrencyCode;